var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-3 pa-3",attrs:{"flat":"","color":"white"}},[_c('v-container',[_c('v-row',{attrs:{"justify":"start"}},[_c('google-drive-auth')],1)],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }